<template>
  <div id="app">
    <GPSReader v-on:route-updated="updateRoute"></GPSReader>
    <OLMap
      :route="routeInfo.route"
      :start="routeInfo.start"
      :end="routeInfo.end"
      :max="routeInfo.max"
    ></OLMap>
  </div>
</template>

<script>
import OLMap from "./components/OLMap.vue";
import GPSReader from "./components/GPSReader.vue";
export default {
  name: "app",
  data() {
    return {
      routeInfo: { route: [[[0, 0]]], max: 15, start: "", end: "" }
    };
  },
  components: {
    OLMap,
    GPSReader
  },
  methods: {
    updateRoute(newRouteInfo) {
      this.routeInfo = newRouteInfo;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
